export default __webpack_public_path__ + "static/media/teenage.f99fd7b6.svg";